import HomeBannerAnimation from './HomeBannerAnimation';

import {
    Row,
    Col,
    Button
} from 'reactstrap';

import polaroids from '../../../assets/images/polaroids.png';

const HomeBanner = (props) => {

    return (
        <section className="bg-mainbanner mt-nav">
            <div className="container py-5 px-sm-4">
                <Row>
                    <Col className="mb-sm-4 py-sm-3" lg="5" md="6">
                        <div className="d-flex gap-3 align-items-center justify-content-start mb-5">
                            <div className="d-flex flex-column">
                                <span className="mb-0 text-slate text-header">Backpacker</span>
                                <div className="mt-0 text-gradient">
                                    <HomeBannerAnimation />
                                </div>
                            </div>
                        </div>
                        <div className="mb-5 text-muted">
                            <p>Unlock the magic of India's vibrant tapestry with Backpacker Tours, your trusted companion for unforgettable group tours and exhilarating treks. Our expertly crafted itineraries promise to unveil the hidden gems and authentic experiences that will leave you spellbound.</p>
                        </div>
                        <div className='d-flex gap-3 mb-5'>
                            <div className='p-3 bg-white text-center rounded-4 shadow-md'><span style={{ fontSize: "2rem" }}>🏔️</span><p className='mb-0'>Group Tours</p></div>
                            <div className='p-3 bg-white text-center rounded-4 shadow-md'><span style={{ fontSize: "2rem" }}>⛺</span><p className='mb-0'>Treks & Campings</p></div>
                            <div className='p-3 bg-white text-center rounded-4 shadow-md'><span style={{ fontSize: "2rem" }}>🚐</span><p className='mb-0'>Private Trips</p></div>
                        </div>
                        <div>
                            <a href="#upcomingtrips">
                                <Button className="rounded-pill py-2 px-4 text-white bg-gradient2 border-0">
                                    Explore Trips <i className="bi bi-arrow-down"></i>
                                </Button>
                            </a>
                        </div>
                    </Col>
                    <Col className="position-relative" lg="7" md="6">
                        <img
                            className="d-flex w-88 mx-auto"
                            alt="Backpackertours Banner"
                            src={polaroids}
                        />
                    </Col>
                </Row>
            </div>
        </section>
        // <section className='bg-mainbanner mt-nav'>
        //     <div className='d-flex gap-3 pc-s-5 pc-b-5 pt-5'>
        //         <div className='banner-content pc-t-5'>
        //             <div className="d-flex gap-3 align-items-center justify-content-start mb-5">
        //                 <div className="d-flex flex-column">
        //                     <span className="mb-0 text-slate banner-header">Backpacker</span>
        //                     <div className="mt-0 text-gradient">
        //                         <HomeBannerAnimation />
        //                     </div>
        //                 </div>
        //             </div>
        //             <div className="mb-5 banner-text">
        //                 <p>Unlock the magic of India's vibrant tapestry with Backpacker Tours, your trusted companion for unforgettable group tours and exhilarating treks. Our expertly crafted itineraries promise to unveil the hidden gems and authentic experiences that will leave you spellbound.</p>
        //             </div>
        //             {/* <div className='d-flex gap-3 mb-5'>
        //                 <div className='p-3 bg-gray text-center rounded-4'><span style={{ fontSize: "2rem" }}>🏔️</span><p className='mb-0'>Group Tours</p></div>
        //                 <div className='p-3 bg-gray text-center rounded-4'><span style={{ fontSize: "2rem" }}>⛺</span><p className='mb-0'>Treks & Campings</p></div>
        //                 <div className='p-3 bg-gray text-center rounded-4'><span style={{ fontSize: "2rem" }}>🚐</span><p className='mb-0'>Private Trips</p></div>
        //             </div> */}
        //             <div>
        //                 <a href="#upcomingtrips">
        //                     <Button className="rounded-pill py-2 px-4 text-white bg-gradient2 border-0">
        //                         Explore Trips <i className="bi bi-arrow-down"></i>
        //                     </Button>
        //                 </a>
        //             </div>
        //         </div>
        //         <div className='d-flex gap-c'>
        //             <div className='pc-t-20'>
        //                 <img className="banner-image" src={banner1} alt="banner 1" />
        //             </div>
        //             <div className="d-flex flex-column gap-c pc-t-9">
        //                 <img className="banner-image" src={banner2} alt="banner 2" />
        //                 <img className="banner-image" src={banner3} alt="banner 3" />
        //             </div>
        //             <div className='d-flex flex-column gap-c'>
        //                 <img className="banner-image" src={banner4} alt="banner 4" />
        //                 <img className="banner-image" src={banner5} alt="banner 5" />
        //             </div>
        //         </div>
        //     </div>
        // </section>
    );
};

export default HomeBanner;